import React from "react";
import { StatusChip } from "./RunPanel";
import { when } from "./api";
import styles from "./ZohoBilling.module.css";

// Recent runs of one kind as a row of pills; the selected one opens below.
export default function RunPicker({ runs, current, onSelect, activeRunId }) {
  if (!runs.length) return null;
  return (
    <div className={styles.pickerRow}>
      <span className={styles.muted}>Recent:</span>
      {runs.slice(0, 8).map((r) => (
        <button
          type="button"
          key={r.id}
          className={`${styles.pick} ${r.id === current ? styles.pickActive : ""}`}
          onClick={() => onSelect(r.id)}
          title={r.input?.files?.map((f) => f.name).join(", ") || ""}
        >
          #{r.id} · {when(r.createdAt)} <StatusChip status={r.id === activeRunId && r.status === "uploaded" ? "running" : r.status} />
        </button>
      ))}
    </div>
  );
}
